<template>
  <div>
    <el-dialog :visible.sync="visible" custom-class="whaty-dialog-form" :width="formDialogWidth"
               @close="handleDialogClose">
      <div slot="title" class="popup-head">
        <span class="popup-tit">{{ formConfig.title || '&nbsp;' }}</span>
      </div>
      <el-scrollbar class="whaty-scroll">
        <!-- TODO: 自动根据window设置最大高度 -->
        <div>
          <common-form
            ref="myForm"
            :formConfig="formConfig"
            :showHeader="false"
            :showFooter="false"
            @submit-start="submitStart"
            @submit-success="submitSuccess"
            @submit-error="submitError"
            @change-router="handleChangeRouter"
          ></common-form>
        </div>
      </el-scrollbar>
      <div slot="footer" class="popup-foot" :style="{'text-align': (formConfig.footerAlign ? formConfig.footerAlign : 'right')}">
        <a href="javascript:" class="btn btn-solid" @click="handleSubmit">提交</a>
        <a href="javascript:" class="btn btn-hollow" @click="handleCancel">取消</a>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import CommonForm from './common-form'
  // import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event'

  export default {
    name: 'dialog-form',
    components: {CommonForm},
    props: {
      formConfig: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        visible: false
        // formDialogWidth: '46%'
      }
    },
    computed: {
      formDialogWidth: function () {
        let editColumns = []
        if (this.formConfig && this.formConfig.fields && this.formConfig.fields.length > 0) {
          for (let i = 0; i < this.formConfig.fields.length; i++) {
            let field = this.formConfig.fields[i]
            if (!field.id) {
              continue
            }
            // 收集允许编辑的字段
            if (field.canEdit) {
              editColumns.push(field)
            }
          }
        }
        // 根据可编辑字段的个数,设置显示样式(单列/两列)
        return editColumns.length > 6 ? '66%' : '46%'
      }
    },
    methods: {
      show() {
        this.visible = true
        this.resetForm()
      },
      hide() {
        this.visible = false
      },
      // 重置form表单
      resetForm() {
        if (this.$refs.myForm) {
          this.$refs.myForm.resetForm()
        }
      },
      // form dialog关闭时被触发
      handleDialogClose() {
        this.resetForm()
        this.$emit('close')
      },
      submitStart() {
        this.$emit('submit-start')
      },
      submitSuccess() {
        this.$emit('submit-success')
      },
      submitError() {
        this.$emit('submit-error')
      },
      handleChangeRouter(router) {
        this.$emit('change-router', router)
      },
      handleSubmit() {
        this.$refs.myForm.handleSubmit()
      },
      handleCancel() {
        this.hide()
      },
      calculateDialogFormHeight() {
        console.log(this.formConfig.title)
      }
    },
    mounted() {
      // TODO: 增加window高度监听事件，改变dialog form高度
    },
    beforeDestroy() {
      // TODO: 去掉window高度变化的监听事件
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/grid/dialog-form.vue